import {PortalStaticContentParamType} from 'Core/ducks/footer';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';

const taxportYearAPIUrl = `/api/commissions/v1/getTaxYears`;

const getTaxYears = async (params: PortalStaticContentParamType) => {
  const queryParams = new URLSearchParams(params).toString();
  const requestUrl = `${taxportYearAPIUrl}?${queryParams}`;

  const response = await axiosInstance.get(requestUrl, getAxiosConfig());

  return handleResponse(response);
};

export default {
  getTaxYears,
};
